import { render, staticRenderFns } from "./adminEdit.vue?vue&type=template&id=70228afa&scoped=true&"
import script from "./adminEdit.vue?vue&type=script&lang=js&"
export * from "./adminEdit.vue?vue&type=script&lang=js&"
import style0 from "./adminEdit.vue?vue&type=style&index=0&id=70228afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70228afa",
  null
  
)

export default component.exports